// extracted by mini-css-extract-plugin
export var description = "Holder__description-cv9mC";
export var phrase = "Holder__phrase-EmBS3";
export var tag = "Holder__tag-G8-3o";
export var title = "Holder__title--YD1R";
export var type = "Holder__type-zng9A";
export var wrapper = "Holder__wrapper-MeIVh";